import './styles/Chatbot.scss';
import Chatbot from './js/Chatbot';

export default Chatbot;
